import { Button, Card, CardContent, Chip, Grid, Skeleton, TextField as MuiTextField, Typography, Stack, CircularProgress } from '@mui/material'
import { Box, Container } from '@mui/system'
import React, { useRef } from 'react'
import ModalBox from '../components/ModalBox';
import { useState } from "react";
// import PaymentModal from './subscriptions/PaymentModal';
import { useEffect } from 'react';
import useAxiosPrivate from '../hooks/use-axios-private';
import { Field, Form, Formik } from 'formik';
import { alertMsg } from '../utils/basicUtils';
import { TextField } from 'formik-mui';
import * as Yup from 'yup';
import Empty from '../components/Empty';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useTheme } from '@emotion/react'
import PhoneInput from 'react-phone-input-2'
import { ErrorMessage } from 'formik';
import Popup from '../components/Popup';
import { useDispatch } from 'react-redux';
import { authActions } from '../redux/reducers/auth-slice';
import 'react-phone-input-2/lib/style.css'
import StrictNumberField from '../components/StrictNumberField';
import { APP_CURRENCY } from '../constants';
import PayModal from './subscriptions/PayModal';

const PRICE_RANGE = [100, 200, 500, 1000, 2000]

const createAddressValidation = Yup.object({
    first_name: Yup.string()
        .required('First name is required')
        .matches(/^[a-zA-Z\s]+$/, 'First name cannot contain special character and numbers')
        .min(3, 'First name must be at least 3 characters')
        .max(35, 'First name cannot exceed 35 characters'),
    last_name: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, 'Last name cannot contain special character and numbers')
        .min(1, 'Last name minimum have 1 characters')
        .max(35, 'Last name cannot exceed 35 characters'),
    street: Yup.string()
        .required('Street is required')
        .max(50, 'Street cannot exceed 50 characters'),
    city: Yup.string()
        .required('City is required')
        .matches(/^[a-zA-Z\s]+$/, 'This City cannot contain special character and numbers')
        .max(50, 'City cannot exceed 50 characters'),
    state: Yup.string()
        .required('State is required')
        .matches(/^[a-zA-Z\s]+$/, 'This State cannot contain special character and numbers')
        .max(50, 'State cannot exceed 50 characters'),
    country: Yup.string()
        .required('Country is required')
        .max(45, 'Country cannot exceed 45 characters'),
    zipcode: Yup.string()
        .required('Zipcode is required')
        .matches(/^[aA-zZ0-9\s]+$/, 'Invalid zipcode')
        .max(50, 'zipcode cannot exceed 50 characters'),
    mobile_number: Yup.string()
        .required('Mobile number is required')
        .min(10, 'Mobile number must be at least 10 numbers')
        .max(15, 'Mobile number cannot exceed 15 characters'),
})

const BillingAddress = (props) => {

    const { address, onEdit, onDefaultSet, onDelete } = props
    const editHandler = () => {
        onEdit()
    }
    const deleteHandler = () => {
        onDelete()
    }
    const defaultClickhandler = () => {
        onDefaultSet()
    }

    return (

        < Box sx={{ pt: 3, borderTop: "1px solid #e6e6e6", pb: 2 }}>
            <Grid container spacing={{ xs: 2, }}>
                <Grid item xs={12} md={5} sx={{}}>
                    <Box>
                        <Typography sx={{ fontSize: "16px" }}>{address.first_name} {address.last_name}</Typography>
                    </Box>
                    <Box>
                        <Typography variant='span' sx={{ fontSize: "14px", marginRight: "5px" }}>{address.street}</Typography>
                        {/* <Typography variant='span' sx={{ fontSize: "14px" }}>MHB Colony</Typography> */}
                    </Box>
                    <Box>
                        <Typography variant='span' sx={{ fontSize: "14px", marginRight: "5px" }}>{address.city}</Typography>
                        <Typography variant='span' sx={{ fontSize: "14px" }}>{address.state}</Typography>
                    </Box>
                    <Box>
                        <Typography variant='span' sx={{ fontSize: "14px", marginRight: "5px" }}>{address.country}</Typography>
                        <Typography variant='span' sx={{ fontSize: "14px" }}>{address.zipcode}</Typography>
                    </Box>
                    <Box>
                        <Typography variant='span' sx={{ fontSize: "14px", marginRight: "5px" }}>+{address.mobile_code} {address.mobile_number}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} lg={7} sx={{ pr: 1 }} >
                    <Box sx={{ display: "flex", justifyContent: "space-between", whiteSpace: 'nowrap', flexWrap: { xs: 'wrap', sm: 'nowrap' }, gap: 2 }}>
                        <Box sx={{ mt: 1 }}>
                            {
                                address.is_default ?
                                    <Chip label="Default" color="success" />
                                    :
                                    <Button onClick={defaultClickhandler} variant="outlined">Set as default</Button>
                            }
                        </Box>
                        <Box sx={{ mt: 1 }}>
                            <Button
                                startIcon={<EditOutlinedIcon />}
                                variant="outlined"
                                onClick={editHandler}
                            >Edit</Button>
                        </Box>

                        <Box sx={{ mt: 1 }}>
                            {
                                address.is_default ?
                                    ""
                                    :
                                    <Button
                                        startIcon={<DeleteOutlineOutlinedIcon />}
                                        variant="outlined"
                                        color="error"
                                        onClick={deleteHandler}
                                    >Delete</Button>
                            }

                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box >
    )
}

const BILLINGADDRESSVALUES =
{
    "first_name": "",
    "last_name": "",
    "country_code": "in",
    "mobile_code": "+91",
    "mobile_number": "",
    "street": "",
    "city": "",
    "state": "",
    "country": "",
    "zipcode": "",
}

const Subscription = () => {
    const theme = useTheme()
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    const [opencard, setOpenCard] = useState(false)
    const [credits, setCredits] = useState(false)
    const [billingAddresses, setBillingAddresses] = useState([])
    const [addressOperation, setAddressOperation] = useState('Create')
    const [billingAddressValues, setBillingAddressValues] = useState(BILLINGADDRESSVALUES)
    const [wallet, setWallet] = useState({})
    const axios = useAxiosPrivate()
    const [paymentAmount, setPaymentAmount] = useState(0)
    const [showAlert, setShowAlert] = useState(false);
    const [billingAddressObj, setBillingAddressObj] = useState({})
    // const [openPaymentModal, setOpenPaymentModal] = useState(false)
    // const [paymentLink, setPaymentLink] = useState("")
    // const paymentWindow = useRef(false)

    const paymentValidation = Yup.object({
        amount: Yup.number()
            .required('Amount is required')
            .min(1, 'Amount should be greater than or equal to 1')
            .max((wallet.wallet_limit - wallet.wallet_amount) || 0, `Amount should not exceed ${(wallet.wallet_limit - wallet.wallet_amount) || 0}`),
    })

    const getAvailableCredits = async () => {
        try {
            const response = await axios.get("users/wallet/")
            dispatch(authActions.updateWallet(response.data.data.wallet))
            setWallet(response.data.data.wallet)
        }
        catch (error) {
            console.error(error)
        }
    }


    const getBillingAddresses = async () => {
        try {
            const resp = await axios.get(`users/billing_address/`)
            setBillingAddresses(resp.data.data.billing_address)
        }
        catch (err) {
            console.error(err)
        }
    }

    const setDefaultBillingAddress = async (id) => {
        try {
            const resp = await axios.post(`users/default_billing_address/`, { billing_address_id: id })
            getBillingAddresses()
            alertMsg(resp.data.message, "success")
        }
        catch (err) {
            console.error(err)
        }
    }

    const deleteBillingAddress = async (id) => {
        try {
            const resp = await axios.delete(`users/billing_address/${id}`)
            getBillingAddresses()
            alertMsg(resp.data.message, "success")
        }
        catch (err) {
            console.error(err)
        }
    }

    // const getPaymentUrl = async (amount) => {
    //     try {
    //         const resp = await axios.post(`payments/create_order/`, { amount })
    //         console.log("🚀 ~ file: Subscription.jsx:222 ~ paymentUrl ~ resp:", resp)
    //         paymentWindow.current = window.open(resp.data.data.link, "payment window", "popup")
    //         console.log("🚀 ~ file: Subscription.jsx:227 ~ getPaymentUrl ~ windowControl:", paymentWindow.current)
    //         var timer = setInterval(function () {
    //             if (paymentWindow.current.closed) {
    //                 clearInterval(timer);
    //                 setOpenPaymentModal(false)
    //                 getAvailableCredits();
    //             }
    //         }, 500);
    //         setOpenPaymentModal(true)
    //     }
    //     catch (err) {
    //         console.error("🚀 ~ file: Subscription.jsx:223 ~ paymentUrl ~ err:", err)
    //     }
    // }


    useEffect(() => {
        getBillingAddresses()
        getAvailableCredits()
        return () => {
        }
    }, [])

    return (
        <Container maxWidth="xl" sx={{ mb: 2 }}>
            <Box flex={5}>
                <Box sx={{ mt: 3 }}>
                    <Typography sx={{ position: 'relative', pl: 1, fontSize: { xs: 20, md: 22, xl: 25 }, fontWeight: theme.palette.mode === "dark" ? '400' : '500', "&::after": { content: '""', position: 'absolute', background: '#f764a3', width: '3px', left: 0, top: '12.5%', bottom: '12.5%', borderRadius: 1 } }}>Wallet</Typography>
                </Box>
                <>
                    <Grid container spacing={{ xs: 2, md: 3, }} sx={{ pt: 3, pb: 0 }} flexDirection={{ xs: "column-reverse", xl: "row" }}>
                        <Grid item xs={12} xl={8}>
                            <Card sx={{ p: 2, pb: 1, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
                                <CardContent sx={{ p: { xs: 0, sm: 2 } }}>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2} sx={{ pb: 3 }}>
                                        <Box>
                                            <Typography sx={{ fontSize: { xs: 18, xl: 20 }, fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> Billing Address </Typography>
                                        </Box>
                                        <Box sx={{ mr: 1, textAlign: 'right' }}>
                                            <Button variant="outlined" onClick={() => {
                                                setAddressOperation('Create')
                                                setBillingAddressValues(BILLINGADDRESSVALUES)
                                                setOpen(true)
                                            }}>Add new</Button>
                                        </Box>
                                    </Stack>

                                    {

                                        billingAddresses.length > 0
                                            ?
                                            < Box className="overflow-scroll" sx={{ maxHeight: "500px", overflow: "auto" }}>

                                                {
                                                    billingAddresses.map(address => (
                                                        <BillingAddress
                                                            key={address.id}
                                                            onEdit={async () => {
                                                                setBillingAddressValues({ ...address })
                                                                setOpen(true);
                                                                setAddressOperation('Update')
                                                            }}
                                                            onDelete={() => {
                                                                setShowAlert(true)
                                                                setBillingAddressObj({ ...address })
                                                            }}
                                                            onDefaultSet={() => setDefaultBillingAddress(address.id)}
                                                            address={address}

                                                        />
                                                    ))
                                                }
                                            </Box>
                                            :
                                            <Empty sx={{ border: "none", }} icon={<MonetizationOnOutlinedIcon sx={{ fontSize: 40, color: "grey" }} />} text="No billing address available" />
                                    }

                                    <Popup show={showAlert} onSecondaryClick={() => setShowAlert(false)} title={"Delete Billing Address?"} consent={true} variant='error' primaryBtnTxt={"Delete"}
                                        onPrimaryClick={async (e, loader) => {
                                            if (e.detail !== 1) {
                                                return false
                                            }
                                            try {
                                                loader(true)
                                                await deleteBillingAddress(billingAddressObj.id)
                                                setShowAlert(false)
                                                loader(false)
                                            }
                                            catch (error) {
                                                console.error(error)
                                            }
                                        }}
                                    >
                                        <Box sx={{ mt: 2, textAlign: "center" }}>
                                            <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Are you sure you want to delete</Typography>
                                            <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "500", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> {billingAddressObj.first_name} {billingAddressObj.last_name}</Typography>
                                            <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> billing address?</Typography>
                                        </Box>
                                        <Box sx={{ marginTop: "6px", textAlign: "center" }}>
                                            <Typography sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>You can't undo this action.</Typography>
                                        </Box>
                                    </Popup>
                                </CardContent>
                                {/* <CardActions sx={{ justifyContent: "center", mt: 3 }}>
                                    <Box>
                                        <Button size="large" variant="outlined">Add More</Button>
                                    </Box>
                                </CardActions> */}
                            </Card>
                        </Grid>
                        <Grid item xs={12} xl={4}>
                            <Card sx={{ p: 2, pb: 1, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
                                <CardContent>
                                    <Box>
                                        <Typography sx={{ fontSize: { xs: 18, xl: 20 }, fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
                                            Credits Available
                                        </Typography>
                                    </Box>
                                    <Box>
                                        {
                                            wallet.wallet_amount ?

                                                <Typography sx={{ fontSize: 36, mt: 5, textAlign: "center", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
                                                    {APP_CURRENCY.currency_symbol} {wallet.wallet_amount}
                                                </Typography>
                                                :
                                                <Box sx={{ width: "90px", mt: 5, mx: "auto" }}>
                                                    <Skeleton sx={{ height: "56px" }} animation="wave" />
                                                </Box>
                                        }
                                    </Box>

                                    {
                                        wallet.wallet_limit ?
                                            <Box sx={{ textAlign: "center", pt: 2 }}>
                                                <Typography>Available top up limit upto ${wallet.wallet_limit}</Typography>
                                            </Box>
                                            :
                                            <Box sx={{ width: "240px", pt: 2, mx: "auto" }}>
                                                <Skeleton sx={{ height: "25px" }} animation="wave" />
                                            </Box>
                                    }

                                    <Box>
                                        <Formik
                                            initialValues={{ amount: 0 }}
                                            onSubmit={async (values, { setSubmitting, setFieldValue, resetForm }) => {
                                                // setCredits(true)
                                                // setPaymentAmount(values.amount)
                                                try {
                                                    setCredits(true)
                                                    setPaymentAmount(values.amount)
                                                }
                                                catch (err) {
                                                    console.error("🚀 ~ file: Subscription.jsx:367 ~ onSubmit={ ~ err:", err)
                                                }
                                                // setSubmitting(false)

                                            }}
                                            validationSchema={paymentValidation}
                                        >
                                            {
                                                ({ setFieldValue, isSubmitting }) => (
                                                    <Form>
                                                        <Box sx={{ pt: 3 }}>
                                                            <Grid container spacing={{ xs: 3 }} sx={{ justifyContent: "center" }}>
                                                                {
                                                                    PRICE_RANGE.map((price, index) => (
                                                                        <Grid key={index} item onClick={() => {
                                                                            setFieldValue('amount', price)
                                                                        }}>
                                                                            <Box>
                                                                                <Chip label={price} />
                                                                            </Box>
                                                                        </Grid>
                                                                    ))
                                                                }
                                                            </Grid>
                                                        </Box>
                                                        <Box>
                                                            <Box sx={{ pt: 4, textAlign: "center", pb: 3 }}>
                                                                <StrictNumberField name="amount" label="Enter Amount *" inputProps={{ min: 0, }} autoComplete='off' component={TextField} type="number" fullWidth />

                                                            </Box>
                                                            <Box sx={{ textAlign: "center", mt: 2 }}>
                                                                <Button type='submit' variant="outlined">Add {isSubmitting && <CircularProgress className="" sx={{ ml: 1, width: "16px !important", height: "16px !important", }} />}</Button>
                                                            </Box>
                                                        </Box>
                                                    </Form>
                                                )
                                            }
                                        </Formik>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                        {/* <Grid item xs={12} sm={3}>
                            <Card sx={{ p: 2, pb: 1, }}>
                                <CardContent>
                                    <Box>
                                        <Typography sx={{ fontSize: 20 }}>
                                            Card Payment
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography sx={{ fontSize: 36, mt: 5, textAlign: "center" }}>
                                            $200.00
                                        </Typography>
                                    </Box>
                                    <Box sx={{ textAlign: "center", mt: 3 }}>
                                        <Button size="large" variant="outlined" onClick={() => {
                                            setOpenCard(true)
                                        }}>Add More</Button>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid> */}
                    </Grid>
                </>
            </Box >

            <ModalBox
                open={open}
                onClose={() => { setOpen(false) }} >
                <Box sx={{ height: { xs: "80vh", sm: 'auto' }, overflow: 'auto', pr: 2 }} className="overflow-scroll">
                    <Box>
                        <Typography sx={{ fontSize: { xs: 20, xl: 22 }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> {addressOperation} Billing Address </Typography>
                    </Box>
                    <Formik
                        initialValues={billingAddressValues}


                        onSubmit={async (values, { setSubmitting, resetForm }) => {
                            let resp = false
                            if (addressOperation === 'Update') {
                                try {
                                    resp = await axios.put(`users/billing_address/${values.id}`, { ...values })
                                } catch (e) {
                                    console.error(e)
                                    alertMsg('Failed to update billing address', 'error')
                                    return
                                }
                            } else {
                                try {
                                    resp = await axios.post('users/billing_address/', { ...values, })
                                    resetForm()

                                } catch (e) {
                                    console.error(e)
                                    alertMsg('Failed to create billing address', 'error')
                                    return
                                }
                            }
                            setSubmitting(false);
                            getBillingAddresses()
                            alertMsg(resp.data.message, 'success')
                            setOpen(false)

                        }}
                        validationSchema={createAddressValidation}
                    >
                        {({ setFieldValue, values, setFieldTouched }) => (
                            <Form>
                                <Grid container spacing={{ xs: 2, md: 3 }} sx={{ pt: { xs: 2, sm: 4 } }}>
                                    <Grid item xs={12} sm={6} >
                                        <Box>
                                            <Field
                                                component={TextField}
                                                name="first_name"
                                                label="First Name *"
                                                inputProps={{ maxLength: 35 }}
                                                variant="outlined"
                                                fullWidth
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <Box>
                                            <Field
                                                component={TextField}
                                                name="last_name"
                                                label="Last Name "
                                                inputProps={{ maxLength: 35 }}
                                                variant="outlined"
                                                fullWidth
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <Box sx={{ color: "#d32f2f", fontSize: "12px" }}>
                                            {/* <Field
                                                component={TextField}
                                                name="mobile_number"
                                                label="Mobile *"
                                                variant="outlined"
                                                fullWidth
                                            /> */}
                                            <PhoneInput
                                                className="phone-inp"
                                                country={'us'}
                                                value={values.mobile_code + values.mobile_number}
                                                onBlur={() => { setFieldTouched({ 'mobile_number': true }) }}
                                                onChange={(mobileNumber, mobileNumberObj) => {
                                                    setFieldValue('mobile_number', mobileNumber.slice(mobileNumberObj.dialCode.length))
                                                    setFieldValue('mobile_code', mobileNumberObj.dialCode)
                                                }}
                                                fullWidth
                                            />
                                            <ErrorMessage name="mobile_number" />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <Box>
                                            <Field
                                                component={TextField}
                                                name="street"
                                                label="Street name *"
                                                inputProps={{ maxLength: 50 }}
                                                variant="outlined"
                                                fullWidth
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <Box>
                                            <Field
                                                component={TextField}
                                                name="city"
                                                label="City *"
                                                variant="outlined"
                                                inputProps={{ maxLength: 50 }}
                                                fullWidth
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <Box>
                                            <Field
                                                component={TextField}
                                                name="state"
                                                label="State *"
                                                inputProps={{ maxLength: 50 }}
                                                variant="outlined"
                                                fullWidth
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <Box>
                                            <Field
                                                component={TextField}
                                                name="country"
                                                label="Country *"
                                                variant="outlined"
                                                fullWidth
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <Box>
                                            <Field
                                                component={TextField}
                                                name="zipcode"
                                                label="Zip Code *"
                                                variant="outlined"
                                                inputProps={{ maxLength: 50 }}
                                                fullWidth
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Box sx={{ mt: 4, display: "flex", justifyContent: "end" }}>

                                    <Box>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            sx={{ mr: 2 }}
                                            onClick={() => setOpen(false)}
                                        >
                                            Cancel
                                        </Button>
                                    </Box>
                                    <Box>
                                        <Button type="submit" variant="contained">Save</Button>
                                    </Box>
                                </Box>

                            </Form>)}
                    </Formik>
                </Box>
            </ModalBox>
            <ModalBox
                open={opencard}
                onClose={() => { setOpenCard(false) }} >
                <Box>
                    <Box>
                        <Typography sx={{ fontSize: { xs: 20, xl: 22 }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> Enter the card details </Typography>
                    </Box>
                    <Grid container spacing={{ xs: 2, md: 3, }} sx={{ pt: 2, }}>
                        <Grid item xs={12} sm={6} >
                            <Box>
                                <MuiTextField label="Card Number" variant="outlined" fullWidth />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            <Box>
                                <MuiTextField label="Card Holder Name *" variant="outlined" fullWidth />
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container spacing={{ xs: 2, md: 3, }} sx={{ pt: 3 }}>
                        <Grid item xs={12} sm={4} >
                            <Box>
                                <MuiTextField label="MM" variant="outlined" fullWidth />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={4} >
                            <Box>
                                <MuiTextField label="YYYY" variant="outlined" fullWidth />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={4} >
                            <Box>
                                <MuiTextField label="CVV" variant="outlined" fullWidth />
                            </Box>
                        </Grid>
                    </Grid>
                    <Box sx={{ textAlign: "right", mb: 2, pt: 3 }}>
                        <Button variant="contained">Pay And Confirm</Button>
                    </Box>
                </Box>
                <Box sx={{ mt: 4, textAlign: "right", borderTop: "1px solid #dcdcdc" }}>
                    <Box sx={{ pt: 3 }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            sx={{ ml: 2 }}
                            onClick={() => setOpenCard(false)}
                        >
                            Close
                        </Button>
                    </Box>
                </Box>
            </ModalBox>
            {/* {credits && <PaymentModal paymentAmount={paymentAmount} open={credits} onClose={() => { setCredits(false) }} onPaymentSuccess={(data) => { setWallet(data.data.wallet); dispatch(authActions.updateWallet(data.data.wallet)); setCredits(false) }} />} */}

            {credits && <PayModal open={credits} paymentAmount={paymentAmount} onPaymentComplete={() => { setCredits(false); getAvailableCredits(); }} />}
        </Container >
    )
}

export default Subscription